import HowItWorksSectionBase from "../../Common/HowItWorksSection/HowItWorksSectionBase";
import PenIcon from "../../../../assets/icons/traffic/toggleable/IconWriting";
import IncomingCallIcon from "../../../../assets/icons/traffic/toggleable/IconIncomingCall";
import HandshakeIcon from "../../../../assets/icons/traffic/toggleable/IconShakeHands";

const HowItWorksSectionEmploymentLaw = () => {
  return (
    <HowItWorksSectionBase
      sections={[
        {
          title: "1. Fall schildern",
          description: "Sie schildern Ihren Fall und können Unterlagen zu Ihrem Arbeitsvertrag hochladen.",
          icon: PenIcon,
        },
        {
          title: "2. Direkt Hilfe erhalten",
          description:
            "Wünschen Sie telefonische Beratung oder sollen auch rechtliche Schritte eingeleitet werden? Sie entscheiden und erhalten direkt professionelle Hilfe.",
          icon: IncomingCallIcon,
        },
        {
          title: "3. Weitere Schritte einleiten",
          description: "Wir prüfen Ihren Fall und setzen uns dafür ein, dass Sie zu Ihrem Recht gelangen!",
          icon: HandshakeIcon,
        },
      ]}
    />
  );
};

export default HowItWorksSectionEmploymentLaw;
